<template>
  <div>
    <top-message />
    <div class="content">
      <div
          v-if="getSourceType === '5' ||getSourceType === '1' || getSourceType === '2'"
          label="银行授权书"
          name="second"
        >
          <BankAuthLett ref="trustList"></BankAuthLett>
        </div>
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="数据上报" name="first">
          <div class="content2">
            <div class="a1">{{ year }}年{{ month }}月信易贷业务报送</div>
            <div class="a2">截止时间：{{ year }}年{{ month }}月{{ days }}日</div>
            <div class="a3">
              <img src="@/assets/images/excel.png" alt />
              <div>
                信易贷报送模板
                <span @click="xiazai" style="color: blue">下载</span>
              </div>
            </div>
            <div class="a4">
              <div class="b1">
                请点击上传
                <el-upload
                  class="upload-demo"
                  accept=".xlsx, .xls"
                  action="#"
                  :on-success="handleAvatarSuccess"
                  :auto-upload="false"
                  :limit="1"
                  ref="excelUpload"
                  :on-change="handName"
                  :on-remove="handleRemovedata"
                >
                  <div>
                    <a @click="seletFile">选择文件</a>
                  </div>
                </el-upload>
              </div>
              <div class="b2">*仅支持上传xls/xlsx文件</div>
              <div class="b3">
                <img src="@/assets/images/excel.png" alt />
                <div>
                  {{ this.Name }}
                </div>
              </div>
            </div>
            <div>
              <el-button class="myMainButton" @click="goHistory">查看记录</el-button>
              <el-button type="primary" class="myPrimaryButton" @click="handleUpload">上传</el-button>
            </div>
          </div>
          <div>
            <el-dialog title="历史记录" width="60%" :visible.sync="dialogHistory">
              <el-table :data="lookTabData">
                <el-table-column :show-overflow-tooltip="true" prop="created" label="名称">
                  <template slot-scope="{ row }">
                    <span>{{ row.created }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="create_time" label="上传时间">
                  <template slot-scope="{ row }">
                    <span>{{ row.create_time }}</span>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="file_name" label="文件名称">
                  <template slot-scope="{ row }">
                    <span>{{ row.file_name }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="{ row }">
                    <el-button @click="downlUpload(row)" type="text">下载</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="text-align: right; margin-top:30px;">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 30, 40,50]"
                  :page-size="100"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="dataTotal"
                ></el-pagination>
              </div>
            </el-dialog>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-if="getSourceType === '5' ||getSourceType === '1' || getSourceType === '2'"
          label="银行授权书"
          name="second"
        >
          <BankAuthLett ref="trustList"></BankAuthLett>
        </el-tab-pane>
        <el-tab-pane label="信用中心" name="center">
          <TrustCenter ref="centerList"></TrustCenter>
        </el-tab-pane>
      </el-tabs> -->
    </div>
  </div>
</template>

<script>
import TopMessage from "@/components/TopMessage";
import baseUrl from "@/api/baseUrl";
import { dataUpload, historydata, historyDownload } from "../../api/authmanget";

import TrustCenter from "./center/TrustCenter.vue";
import BankAuthLett from "./center/BankAuthLett.vue";
export default {
  components: { TopMessage, TrustCenter, BankAuthLett },
  computed: {
    getSourceType: function() {
      return this.$store.getters.sourceType;
    }
  },
  data() {
    return {
      activeName: "first",
      dialogHistory: false,
      lookTabData: [],
      dataTotal: 0,
      created: "", //用户名
      fileListdata: [], //信易贷文件
      selectedFile: null,
      historFrom: {
        page: 1,
        pageSize: 10
      },
      year: "",
      month: "",
      days: "",
      Name: "",
      msg: ""
    };
  },
  mounted() {
    this.created = sessionStorage.getItem("userName") || "未知用户";
  },
  methods: {
    // tab切换事件
    handleClick(tab, event) {
      if (tab.name === "second") {
        this.$refs.trustList.getBankList(); // 直接调用子组件方法
      } else if (tab.name === "center") {
        this.$refs.centerList.trustData(); // 直接调用子组件方法
      }
      console.log(tab.name, "dd");
    },
    // 下载excel模板
    xiazai() {
      const xhr = new XMLHttpRequest();
      xhr.open(
        "get",
        this.baseUrl + "/api/v1/bankLicense/downloadLoanInfoExcel",
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader(
        "Content-Type",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      );
      xhr.onload = function() {
        if (this.status === 200) {
          // const blob = this.response;
          const blob = this.response;
          const fileName = "信易贷报送模板文档.xlsx";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send();
    },

    // 选择文件按钮
    seletFile() {
      // 每次点击选择文件先进行清空
      this.$refs.excelUpload.clearFiles();
      this.Name = "";
    },
    // 移除文件事件
    handleRemovedata() {
      this.selectedFile = null;
      this.Name = "";
    },

    // 上传excel模板成功回调
    handleAvatarSuccess(res) {
      console.log(res, "res回调");
      if (res.data.code == 200) {
        this.$refs.excelUpload.clearFiles();
        // this.reason = res.msg;
        this.Name = "";
      } else {
        this.$refs.excelUpload.clearFiles();
        // this.reason = res.msg;
        this.Name = "";
      }
    },
    // 文件改变时候的状态
    handName(file, fileList) {
      const isExcel = /\.(xlsx|xls)$/i.test(file.name);
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isExcel) {
        this.$message.error("只能上传Excel文件!");
        this.$refs.excelUpload.clearFiles();
        return false;
      }
      if (!isLt10M) {
        this.$message.error("文件大小不能超过10MB!");
        return false;
      }
      const fileInput = this.$refs.excelUpload.$el.querySelector(
        "input[type=file]"
      );
      if (fileInput) fileInput.value = "";
      if (fileList.length > 0) {
        this.selectedFile = file.raw; // 保存原始文件对象
      } else {
        this.selectedFile = null;
      }
      this.Name = file.name;
      return true;
    },
    // 上传
    async handleUpload() {
      if (!this.selectedFile) {
        this.$message.warning("请先选择文件");
        return;
      }
      try {
        const created = sessionStorage.getItem("userName") || "未知用户";
        const formData = new FormData();
        formData.append("file", this.selectedFile);
        formData.append("created", created);
        const res = await dataUpload(formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
        this.handleAvatarSuccess(res);
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
        this.$refs.excelUpload.clearFiles();
        this.selectedFile = null;
      } catch (error) {
        console.log(error, "error");

        // this.$message.error(error.response?.data?.message || "上传失败");
      }

      //   this.$refs.upload.submit();
    },
    //  历史记录
    async goHistory() {
      this.dialogHistory = true;
      const res = await historydata({
        ...this.historFrom,
        created: this.created
      });
      this.lookTabData = res.data.data;
      this.dataTotal = res.data.data.tatol;
    },
    // 历史记录下载
    async downlUpload(row) {
      try {
        const { filename, blobData, contentType } = await historyDownload({
          fileName: row.file_name
        });
        const blob = new Blob([blobData], {
          type: contentType
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        // 设置下载文件名（可以从响应头获取，也可以固定）
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // 释放URL对象
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        this.$message.error("下载失败，请重试");
        console.log(error);
      }
      console.log(row, "row");
    },
    // 分页
    handleSizeChange(val) {
      this.historFrom.pageSize = val;
      this.goHistory(this.historFrom);
    },
    handleCurrentChange(val) {
      this.historFrom.page = val;
      this.goHistory(this.historFrom);
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  min-height: 787px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;

  .content2 {
    display: flex;
    flex-direction: column;
    align-items: center;

    .a1 {
      font-weight: 500;
      font-size: 26px;
      color: black;
      margin-bottom: 10px;
    }

    .a2 {
      font-size: 18px;
      color: black;
      margin-bottom: 20px;
    }

    .a3 {
      width: 100%;
      background: #d9ece1;
      padding: 25px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;

      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }

      div {
        font-size: 20px;
        font-weight: 500;

        a {
          color: #2981ee;
          display: inline-block;
          margin-left: 5px;
          cursor: pointer;
          border-bottom: 1px solid #2981ee;
        }
      }
    }

    .a4 {
      width: 100%;
      background: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 30px;
      box-sizing: border-box;
      margin-bottom: 20px;

      .b1 {
        display: flex;
        font-size: 20px;
        font-weight: 500;
        color: #2a2a2a;
        margin-bottom: 10px;

        a {
          color: #2981ee;
          display: inline-block;
          margin-left: 5px;
          cursor: pointer;
          border-bottom: 1px solid #2981ee;
        }
      }

      .b2 {
        display: flex;
        font-size: 18px;
        color: #a2a4ac;
        margin-bottom: 20px;
      }

      .b3 {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        height: 30px;
        padding-top: 20px;
        border-top: 1px solid #dedee0;

        img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }

        div {
          font-size: 16px;
          color: #a9acb7;
        }
      }
    }

    .a6 {
      width: 60px;
      height: 60px;
      margin-bottom: 15px;
    }

    .a7 {
      color: black;
      font-size: 20px;
      margin-bottom: 10px;
    }

    .a8 {
      width: 40px;
      height: 40px;
      margin-bottom: 10px;
    }

    .a9 {
      color: black;
      font-size: 24px;
      margin-bottom: 10px;
    }

    .a5 {
      color: #2a2a2a;
      font-size: 15px;
    }
  }
}
</style>